import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'CampCategory';

const CampCategoryApi: any = baseApi(endpoint);

export default CampCategoryApi;